import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class ServiceAreasAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // ******************************
  //        Public methods
  // ******************************

  // GET //
  getManyError() {
    const message = {
      body: 'SERVICE_AREA_GET_MANY_ERROR'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'SERVICE_AREA_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'SERVICE_AREA_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess() {
    const message = {
      body: 'SERVICE_AREA_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'SERVICE_AREA_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE MANY //
  updateManySuccess() {
    const message = {
      body: 'SERVICE_AREA_UPDATE_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateManyError() {
    const message = {
      body: 'SERVICE_AREA_UPDATE_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // REMOVE //
  removeSuccess(serviceArea?) {
    const message = {
      body: 'X_SERVICE_AREA_REMOVE_SUCCESS'
    };
    return this.bringozToastService.success(message, serviceArea)
  }

  removeError() {
    const message = {
      body: 'SERVICE_AREA_REMOVE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteOneSuccess(serviceArea) {
    const message = {
      body: 'X_SERVICE_AREA_DELETE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message, serviceArea)
  }

  deleteOneError() {
    const message = {
      body: 'SERVICE_AREA_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.service-areas')
  .service('serviceAreasAlerts', ServiceAreasAlerts);
